import reducer from './reducer';
import actions from './actions';
import * as selectors from './selectors';

export { reducer, actions, selectors };



// WEBPACK FOOTER //
// ./src/store/reducers/ui/theme/index.js